import { customElement, FASTElement, Observable, observable } from '@microsoft/fast-element';
import { ExecutionTemplate as template } from './execution.template';
import { ExecutionStyles as styles } from './execution.styles';
import {
  IExecutionNotification,
  IExecutionService,
} from '../../services/execution.service';

const name = 'execution-route';

@customElement({
  name,
  template,
  styles,
})
export class Execution extends FASTElement {
  @IExecutionService executionService: IExecutionService;
  @observable isVisible: boolean = true;
  @observable shouldShowTimeBar: boolean = false;
  @observable executionNotifications: IExecutionNotification[];

  private executionNotificationNotifier: any;
  private executionNotificationHandler: any;

  constructor() {
    super();
    this.registerExecutionNotifier();
  }

  public tabSelection(isVisible) {
    this.isVisible = isVisible;
  }

  public updateShouldShowTimeBar(shouldShowTimeBar) {
    this.shouldShowTimeBar = shouldShowTimeBar;
  }

  private registerExecutionNotifier() {
    const _this = this;
    this.executionNotifications = this.executionService.executionNotifications;
    this.executionNotificationNotifier = Observable.getNotifier(this.executionService);
    this.executionNotificationHandler = {
      handleChange() {
        _this.executionNotifications = _this.executionService.executionNotifications;
      },
    };

    this.executionNotificationNotifier.subscribe(
      this.executionNotificationHandler,
      'executionNotifications'
    );
  }
}
